import React from 'react'
import { GridViewProvider } from './Context'
import { Layout } from './Layout'

export const GridView = () => {
  return (
    <GridViewProvider>
      <Layout />
    </GridViewProvider>
  )
}
